import React, { memo } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import styled from 'styled-components';

const PauseIcon = ({ width = 30, height = 30 }) => (
  <PauseSvg width={width} height={height} viewBox="0 0 12 14">
    <path d="M0 14H4V0H0V14ZM8 0V14H12V0H8Z" />
  </PauseSvg>
);

PauseIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

const PauseSvg = styled.svg`
  fill: ${(props) => props.theme.main.iconDefault};
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

export default memo(PauseIcon);
